// extracted by mini-css-extract-plugin
module.exports = {"topLevel":"SideNav_topLevel__2LLMo","productLogo":"SideNav_productLogo__2jX-b"};